module.exports = __webpack_public_path__ + "static/media/silverTop1M.75e5a28f.webp";